import { MepLevelInfoCardBanner } from '@/features';
import { tw } from '@/common';

type FireDangerRating = 'moderate' | 'high' | 'extreme' | 'catastrophic';

export const mepFireDangerRatingBanner: Record<FireDangerRating, MepLevelInfoCardBanner> = {
  moderate: {
    text: 'Moderate',
    backgroundColor: tw`bg-[#64BF30]`,
  },
  high: {
    text: 'High',
    backgroundColor: tw`bg-[#FEDD3A]`,
  },
  extreme: {
    text: 'Extreme',
    backgroundColor: tw`bg-[#F78100]`,
  },
  catastrophic: {
    text: 'Catastrophic',
    backgroundColor: tw`bg-[#AD0909]`,
    textColor: tw`text-white`,
  },
};
